import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';
import deepmerge from 'deepmerge';

import PageHeader from '../../common/page_header';
import { getDefaultPaginationQueryValues } from '../../../core/utils/api_utils';
import useNotification from '../../../core/hooks/use_notification';
import { getPriceListsNotificationData } from '../../../core/utils/notification_utils';
import { getPriceListsAction, getPriceListsState } from '../../../features/price/get_price_lists';
import { Button } from '../../common/button';
import { ROUTE_PRICE_LISTS_NEW } from '../../../core/constants';
import PaginationControls from '../../common/pagination_controls';
import PriceListsList from './price_lists_list';

const initialQueryParams = {
    ...getDefaultPaginationQueryValues
};

const PriceListsPage = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const navigate = useNavigate();

    const getPriceLists = useSelector(getPriceListsState);

    const [queryParams, setQueryParams] = useState(initialQueryParams);

    const refreshList = useCallback(() => {
        dispatch(getPriceListsAction(queryParams))
            .then(response => showErrorMessage(getPriceListsNotificationData(response)));
    }, [dispatch, queryParams, showErrorMessage]);

    useEffect(() => {
        refreshList();
    }, [refreshList]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>
            <PageHeader
                title="Cenniki"
                actions={
                    <Button onClick={ () => navigate(ROUTE_PRICE_LISTS_NEW) }>
                        Dodaj cennik
                    </Button>
                }/>

            { getPriceLists?.loading && <LinearProgress/> }

            { getPriceLists?.data?.content && (
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>
                    <PriceListsList refreshList={ refreshList } queryParams={ queryParams }/>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 1 } }>
                        <PaginationControls
                            currentPage={ getPriceLists?.data?.pageable?.pageNumber }
                            totalPages={ getPriceLists?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            ) }
        </Box>
    );
};

export default PriceListsPage;